export default "__VITE_ASSET__2e78bbbd__"